import Vue from 'vue'
import VueRouter from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import store from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: () => import(/* webpackChunkName: "default" */ '@/views/DefaultLayout.vue'),
    children: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
      meta: {
        title: store.state.app.appName
      }
    },
    {
      path: '/features',
      name: 'features',
      component: () => import(/* webpackChunkName: "features" */ '@/views/Features.vue'),
      meta: {
        title: store.state.app.appName
      }
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import(/* webpackChunkName: "pricing" */ '@/views/Pricing.vue'),
      meta: {
        title: store.state.app.appName
      }
    }]
  },
  {
    path: '/map/:bot/:key',
    name: 'map',
    component: () => import(/* webpackChunkName: "pricing" */ '@/views/PublicMap.vue'),
    meta: {
      title: store.state.app.appName
    }
  },
  {
    path: '/auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/AuthLayout.vue'),
    children: [
      {
        path: '/login',
        name: 'login',
        components: { auth: () => import(/* webpackChunkName: "auth-login" */ '@/views/auth/Login.vue') },
        meta: {
          title: `${store.state.app.appName} Login`
        }
      },
      {
        path: '/signup',
        name: 'signup',
        components: { auth: () => import(/* webpackChunkName: "auth-signup" */ '@/views/auth/Signup.vue') },
        meta: {
          title: `${store.state.app.appName} Sign Up`
        }
      },
      {
        path: 'verify',
        name: 'verify',
        components: { auth: () => import(/* webpackChunkName: "auth-verify" */ '@/views/auth/management/Verify.vue') },
        meta: {
          title: `${store.state.app.appName} Verify`
        }
      },
      {
        path: 'reset',
        name: 'reset',
        components: { auth: () => import(/* webpackChunkName: "auth-reset" */ '@/views/auth/management/ResetPwd.vue') },
        meta: {
          title: `${store.state.app.appName} Verify`
        }
      }
    ]
  },
  {
    path: '/termsofservice',
    name: 'termsofservice',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Terms.vue'),
    meta: {
      title: store.state.app.appName
    }
  },
  {
    path: '/app',
    component: () => import(/* webpackChunkName: "appview" */ '@/views/AppLayout.vue'),
    meta: {
      requiresAuth: true,
      title: `${store.state.app.appName} App`
    },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        components: { app: () => import(/* webpackChunkName: "app-dashboard" */ '@/views/dashboard/Dashboard.vue') },
        meta: {
          title: `${store.state.app.appName} Dashboard`
        }
      },
      {
        path: 'groups',
        name: 'groups',
        components: { app: () => import(/* webpackChunkName: "app-groups" */ '@/views/groups/Groups.vue') },
        meta: {
          title: `${store.state.app.appName} Groups`
        }
      },
      {
        path: 'members',
        name: 'members',
        components: { app: () => import(/* webpackChunkName: "app-members" */ '@/views/members/Members.vue') },
        meta: {
          title: `${store.state.app.appName} Members`
        }
      },
      {
        path: 'members-map',
        name: 'members-map',
        components: { app: () => import(/* webpackChunkName: "app-members" */ '@/views/members/Map.vue') },
        meta: {
          title: `${store.state.app.appName} Members Map`
        }
      },
      {
        path: 'registration',
        name: 'registration',
        components: { app: () => import(/* webpackChunkName: "app-registration" */ '@/views/registration/Registration.vue') },
        meta: {
          title: `${store.state.app.appName} Registration`
        }
      },
      {
        path: 'information',
        name: 'information',
        components: { app: () => import(/* webpackChunkName: "app-information" */ '@/views/information/Information.vue') },
        meta: {
          title: `${store.state.app.appName} Information`
        }
      },
      {
        path: 'messages',
        name: 'messages',
        components: { app: () => import(/* webpackChunkName: "app-messages" */ '@/views/messages/Messages.vue') },
        meta: {
          title: `${store.state.app.appName} Messages`
        }
      },
      {
        path: 'actions',
        name: 'actions',
        components: { app: () => import(/* webpackChunkName: "app-actions" */ '@/views/actions/Actions.vue') },
        meta: {
          title: `${store.state.app.appName} Actions`
        }
      },
      {
        path: 'elaborators',
        name: 'elaborators',
        components: { app: () => import(/* webpackChunkName: "app-elaborators" */ '@/views/elaborators/Elaborators.vue') },
        meta: {
          title: `${store.state.app.appName} Elaborators`
        }
      }
    ]
  },
  {
    path: '/config',
    component: () => import(/* webpackChunkName: "config" */ '@/views/ConfigLayout.vue'),
    meta: {
      requiresAuth: true,
      title: `${store.state.app.appName} Configuration`
    },
    children: [
      {
        path: 'account',
        name: 'account',
        components: { config: () => import(/* webpackChunkName: "config-account" */ '@/views/config/Account.vue') }
      },
      {
        path: 'users',
        name: 'users',
        components: { config: () => import(/* webpackChunkName: "config-users" */ '@/views/config/Users.vue') }
      },
      {
        path: 'bot',
        name: 'bot',
        components: { config: () => import(/* webpackChunkName: "config-bot" */ '@/views/config/Bot.vue') }
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: {
      title: 'Page Not Found'
    }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }
    return goTo(scrollTo, { offset: 100 });
  }
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const nearestWithTitle = to.matched.slice().reverse().find(record => record.meta && record.meta.title);

  const isApiAuthenticated = store.getters['apiAuth/isAuthenticated']
  const isBotAuthenticated = store.getters['botAuth/isAuthenticated']
  const selectedBot = store.getters['app/selectedBot']

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  if (requiresAuth) {
    if (isApiAuthenticated && isBotAuthenticated) {
      return next();
    }

    try {
      if (!isApiAuthenticated) await store.dispatch('apiAuth/authenticate');

      if (isApiAuthenticated && !isBotAuthenticated && (!selectedBot || (selectedBot && selectedBot.active))) {
        await store.dispatch('botAuth/authenticate');
      }
      return next();
    } catch (error) {
      return next({ name: 'login' });
    }
  }

  next();
})

export default router
